const constants = {
  label: "ข้อมูลการรับประกัน"
};

const paths = {
  index: "/remyndWarranty",
  create: "/remyndWarranty/create",
  edit: "/remyndWarranty/edit"
};

export { constants, paths };
